define('home/mixins/withThreadSharing',[
    'jquery',
    'underscore',
], function (
    $,
    _
) {
    'use strict';

    /**
     * Default method for retrieving the thread off the model.
     * Expects the model to have a direct relation to the thread
     * (ex: activity, post), or be the thread itself.
     *
     * @returns {Thread}
     */
    var getThread = function () {
        return this.model.thread || this.model;
    };

    return function () {
        this.events = _.extend({
            'click [data-action=share]': 'handleShareThread',
        }, this.events);

        this.handleShareThread = function (event) {
            if (!event)
                return;

            event.preventDefault();
            event.stopPropagation();

            var thread = getThread.call(this);
            var network = $(event.currentTarget).attr('data-network');

            thread.shareThread(network);
        };
    };
});

